import {EnvInterface} from './scaffolding/env-interface';

const envBaseUrl = 'https://revhubs.mathsturtle.com';

export { environmentStaging as environmentCurrent };

export const environmentStaging: EnvInterface = {
  app: {
    environment: 'staging',
    version: '1.12.3',
    title: 'CGP RevisionHub',
    name: 'Revision Hub',
    cmsEnabled: false,
    cmsIdentifier: 1,
    mediaBaseUrl: 'https://webtest.cgpbooks.co.uk',
  },
  elevenPlus: {
    isEnabled: true,
    isLocalhost: false,
    cloudFrontPath: "_revisionhub_opc/_elevenplusol_opc/ElevenPlusTest5_1_2",
    cloudFrontSamplePath: "_revisionhub_opc/_elevenplusol_opc/ElevenPlusTestSample"
  },
  security: {
    baseUrl: envBaseUrl,
    autoLogoutMinutes: 30,
    //TODO: confirm this
    iframeOrigin: 'https://revhubs.mathsturtle.com',
    // Kentico sites whose users the SSO waiting page may send back for a fresh token
    kenticoOrigins: ['https://webtest.cgpbooks.co.uk', 'https://webtest2.cgpbooks.co.uk'],
    aws_bucket: {
      endpoint: 'https://kentico-app-library-dev.s3.eu-west-1.amazonaws.com',
      bucketName: 'kentico-app-library-dev',
    },
    tuatara: {
      apiKey: 'nhS6C09LjKmOUQ30a0o+lNjGoPLMD5CKMaDTXrkQf8w=',
      endpoint: envBaseUrl + '/api',
    },
    payment: {
      stripe: {
        apiKey: '',
      },
    },
    oauth: {
      google: {
        clientId: '[OURS].apps.googleusercontent.com',
      },
      apple: {
        clientId: 'co.uk.cgpbooks.revhub',
      },
      revhub: {
        clientId: '[KEY].apps.cgpbooks.co.uk',
      },
    },
  },
  googleAnalytics: {
    //Kentico at Millom Test - GA4
    trackerId: 'G-06SP9J98CN',
    purchaseFunnelEnabled: false,
    debugMode: false,
  },
  uatAccess: {
    emails: [],
    bypass: false
  },
  trustPilot: {
    isEnabled: false,
    dataTemplateId: '',
    dataBusinessUnitId: '',
    dataStyleHeight: '',
    dataStyleWidth: '',
    dataStars: '',
    dataTags: '',
    linkUrl: ''
  }
};

